<template>
  <div>
    <b-row>
      <b-modal id="modal-assign" hide-footer ref="escalateSubmissions" title="Escalate Filing">
        <Escalation :task-id="taskId" type="disputes" permission="can_view_continuous_filing_escalations"/>
      </b-modal>
      <b-modal id="modal-a-assign" hide-footer ref="assignSubmissions" title="Assign to Registrar">
        <Assignment :id="taskId" type="cf" permission="can_view_continuous_filing_tasks"/>
      </b-modal>
      <b-modal id="modal-a-reply" hide-footer ref="replySubmissions" title="Reply to Escalation">
        <AssignmentReply :id="taskId" :user-id="sourceId" type="cf"/>
      </b-modal>
      <b-modal id="modal-query" hide-footer ref="query-filing" title="Query Filing">
        <b-col cols="12">
          <b-form class="w-full">
            <b-form-textarea
                v-model="form.rationale"
                type="text"
                placeholder="Give description of query"
                class="mt-1"
                required>
            </b-form-textarea>
            <b-row>
              <b-col cols="4">
                <button type="button" class="btn-query-hover" variant="primary" @click="onQuery">
                  Query<b-spinner v-if="loading" small class="ml-1"></b-spinner></button>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-modal>
      <b-modal id="modal-confirm" hide-footer ref="confirm" title="Confirm">
        <b-row>
          <b-col>
            <p class="text-sm">
              <span class="h6">Are you sure you are ready to take this action?</span>.<br/>
              This action can only be reversed by your superiors. Only confirm if you are certain that this is the appropriate Final Decision
            </p>
            <p class="mt-3 text-sm italic">
              <b>Note:</b><br/>
              All actions performed on <b class="text-blue">URSB eRegistry</b> are recorded and details of the account that initiated are tagged to the action.
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="4">
            <button class="px-3 py-2 border-2 border-blue bg-white rounded-sm text-blue w-full" @click="cancelConfirmation">
              <i class="fa fa-minus-square text-blue mr-2"></i>Cancel</button>
          </b-col>
          <b-col cols="4"></b-col>
          <b-col cols="4">
            <button class="px-3 py-2 bg-green rounded-sm text-white w-full hover:bg-green-dark" @click="yesConfirmation">
              <i class="fa fa-check-circle text-white mr-1"></i> Accept</button>
          </b-col>
        </b-row>
      </b-modal>
    </b-row>
    <b-row class="mx-3 mb-3s" v-if="messages && messages[0] && messages[0].messageData">
      <b-col cols="12">
        <b-row class=" py-2 my-2 shadow-md rounded-sm" style="background: #b0ea75;">
          <b-col cols="10">
            <div class="flex">
              <i class="fa fa-comment-alt text-green mr-1 mt-1"></i>
              <span class="text-capitalize font-bold underline hover:text-green">{{ messages[0].messageData.sender || '—' }}</span>
            </div>
            <p class="text-gray mt-2">
              {{ messages[0].messageData.comment || '—' }}
            </p>
            <span class="italic text-gray" style="font-size: 10px;">{{ dateFormat(messages[0].messageData.createdAt) }}</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row >
      <b-col cols="12">
        <b-row class="mx-1 mt-4" v-if="taskData">
          <b-col>
            <span class="h3 font-bold">{{ taskData.subjectEntity || taskData.companyName || '—' }}</span>
          </b-col>
        </b-row>
        <b-row class="mx-1" v-if="taskData">
          <b-col cols="12">
            <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
              <thead>
              <tr class="bg-gray-pale">
                <td colspan="12" class="px-2 py-2">Filing Details</td>
              </tr>
              <tr>
                <th class="px-2 py-1">Tracking Number</th>
                <th class="px-2 py-1">Status</th>
                <th class="px-2 py-1">Resolution Type</th>
                <th class="px-2 py-1">Submission Date</th>
              </tr>
              </thead>
              <tbody>
              <tr style="border: solid 1px #dedede;" >
                <td class="px-2 py-1">
                  <span class="text-gray">{{ taskData.trackingNo || '—' }}</span>
                </td>
                <td class="px-2 py-1">
                  <span class="text-blue text-capitalize">{{ (application.status || taskData.status || '—').toLowerCase() }}</span>
                </td>
                <td class="px-2 py-1">
                  <span class="text-gray">{{ cleanEntityType(taskData.typeOfChangeBeingFiled || taskData.type || taskData.natureOfDispute) }}</span>
                </td>
                <td class="px-2 py-1">
                  <span class="text-gray italic">{{ dateTimeFormat(application.createdAt || taskData.submissionDate) }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
          <b-col cols="12" v-if="taskData.trackingNo && prnValue">
            <PRNViewer :tracking-number="taskData.trackingNo" :prn="prnValue"/>
          </b-col>
        </b-row>
        <b-row class="my-3 mx-1">
          <b-col cols="6"></b-col>
          <b-col cols="6">
            <div class="flex float-end">
              <button class="btn-escalate" @click="escalatePrompt">
                <i class="fa fa-arrow-up text-blue mr-1"></i>Escalate
              </button>
              <button class="btn-query" v-b-modal.modal-query>
                <i class="fa fa-question text-white mr-1"></i> Query
              </button>
              <button class="btn-approve" @click="onApprove">
                <i class="fa fa-check-circle text-white mr-1"></i>Approve
              </button>
              <button class="btn-approve" @click="replyPrompt">
                <i class="fa fa-reply text-white mr-1"></i> Reply
              </button>
              <button class="btn-approve" @click="assignPrompt">
                <i class="fa fa-hand-pointer text-white mr-1"></i> Assign
              </button>
            </div>
          </b-col>
        </b-row>

        <b-row class="mx-1 mb-5">
          <b-col cols="12">
            <b-row>
              <b-col>
                <div class="flex h-full" style="cursor: pointer;">
                  <div :class="[(currentRoute === 'info') ? 'menu-item-active' : 'menu-item']"
                       @click="select('info')">
                    <div class="flex mt-6">
                      <div style="font-size: 12px">Filing Information</div>
                    </div>
                  </div>
                  <div v-if="taskData && (taskData.typeOfChangeBeingFiled === 'MULTI_CHANGES')" :class="[(currentRoute === 'attachments') ? 'menu-item-active' : 'menu-item']"
                       @click="select('attachments')">
                    <div class="flex mt-6">
                      <div style="font-size: 12px">Attachments</div>
                    </div>
                  </div>
                  <div :class="[(currentRoute === 'messages') ? 'menu-item-active' : 'menu-item']"
                       @click="select('messages')">
                    <div class="flex mt-6">
                      <div style="font-size: 12px">Messages</div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <DisputeResolutionFormDetailsEscalated :task="application.task" v-if="currentRoute === 'info'"/>
                <DisputeResolutionFilesEscalated :task="application.task" v-if="currentRoute === 'attachments'"/>
                <DisputeResolutionMessagesEscalated :task="application.task" v-if="currentRoute === 'messages'"/>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import Escalation from "@/views/home/commons/Escalation";
import moment from "moment";
import PRNViewer from "@/views/home/commons/PRNViewer";
import Assignment from "@/views/home/commons/Assignment";
import AssignmentReply from "@/views/home/commons/AssignmentReply";
import DisputeResolutionFormDetailsEscalated
    from "@/views/home/services/dispute-resolution/escalations/tabs/DisputeResolutionFormDetailsEscalated.vue";
import DisputeResolutionFilesEscalated
    from "@/views/home/services/dispute-resolution/escalations/tabs/DisputeResolutionFilesEscalated.vue";
import DisputeResolutionMessagesEscalated
    from "@/views/home/services/dispute-resolution/escalations/tabs/DisputeResolutionMessagesEscalated.vue";

export default {
  name: "DisputeResolutionEscalationFile",
  components: {
    DisputeResolutionMessagesEscalated,
    DisputeResolutionFilesEscalated,
    DisputeResolutionFormDetailsEscalated,
    AssignmentReply,
    Assignment,
    PRNViewer,
    Escalation},
  props:{
    application:Object
  },
  data(){
    return{
      hasComments: false,
      currentRoute: "info",
      selectedId:null,
      margin:"2px",
      hasContent:false,
      nameIdMap:new Map(),
      loading:false,
      isQueryResponse:false,
      message:null,
      taskId:null,
      sourceId:null,
       form:{
        rationale:null,
        resolutionId:null,
        queueId:null,
        status:null
      },
      report:[],
      analysisReportError:null,
      messages:[],
      menu:[
        {
          title:"Filing Information",
          route:"info",
        },
        {
          title:"Attachment",
          route:"attachments",
        },
        {
          title:"Messages",
          route:"messages",
        },
      ],
      action:null
    }
  },
  mounted() {
    this.sourceId = this.application.sourceId
    this.taskId = this.application.taskId
    this.form.queueId = this.taskId
    const task = this.application.task
    this.form.resolutionId = (task && (task.data && task.data.id)) || (task && task.id)
    this.fetchDisputeResolutionStatuses(this.taskId)
    const trackingNo = task && ((task.data && task.data.trackingNo) || task.trackingNo)
    if (trackingNo) this.fetchDisputeResolutionDetails(trackingNo)
  },
  methods:{
    ...mapActions(["fetchNextDisputeResolution", "fetchDisputeResolutionDetails", "fetchDisputeResolutionStatuses", "fetchDisputeResolutionCount", "updateDisputeResolutionStatus","approveDisputeResolutionApplication"]),
    select(route){
      this.currentRoute = route
    },
    cleanEntityType(name){
      if(name == null){
        return ""
      }
      let n = name.replaceAll("_", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    onApprove(){
      this.action = "approve"
      this.form.status = "CLOSED"
      this.form.rationale = "Approved"
      this.$refs.confirm.show();
    },
    onQuery(){
      this.action = "final"
      this.form.status = "QUERIED"
      if(this.form.rationale != null){
        this.$refs.confirm.show();
      }else{
        this.errorToast("Missing Information", "Provide a message for this final decision")
      }
    },
    onReject(){
      this.action = "final"
      this.form.status = "REJECTED"
      this.$refs.confirm.show();
    },
    escalatePrompt(){
      this.action = "escalate"
      this.$refs.escalateSubmissions.show();
    },
    replyPrompt(){
      this.action = "reply"
      this.$refs.replySubmissions.show();
    },
    assignPrompt(){
      this.action = "assign"
      this.$refs.confirm.show();
    },
    yesConfirmation(){
      if(this.action === "reply"){
        this.$refs.replySubmissions.show();
      }
      if(this.action === "final"){
        this.loading = true
        this.updateDisputeResolutionStatus({id:this.application.taskId,...this.form})
      }
      if(this.action === "approve"){
        const formData = new FormData();

        formData.set("id",this.application.taskId);

        formData.set("hasSummon", false);

        formData.set("rationale", this.form.rationale);

        this.approveDisputeResolutionApplication(formData)
      }
      if(this.action === "assign"){
        this.$refs.assignSubmissions.show();
      }
      if(this.action === "escalate"){
        this.$refs.escalateSubmissions.show();
      }
      this.cancelConfirmation()
    },
    cancelConfirmation(){
      this.action = null
      this.$refs.confirm.hide();
    },
    checkForUpdates(){
      this.loading = true
      window.location.reload()
    },
    cleanString(name){
      let n = name.replaceAll("_", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    dateFormat(date){
      if (!date) return "—"
      return moment(date).format("DD-MM-YYYY")
    },
    dateTimeFormat(date){
      if (!date) return "—"
      return moment(date).format("DD-MM-YYYY HH:mm")
    }
  },
  computed:{
    ...mapGetters([ "getDisputeResolutionAssignmentSuccess", "getDisputeResolutionStatuses",
      "getDisputeResolutionEscalationSuccess", "getDisputeResolutionSuccess", "getDisputeResolutionError", "getDisputeResolutionCount",
      "getDisputeResolutionEscalationSuccess", "getDisputeResolutionStatusUpdate", "getDisputeResolutionDetails"]),
    taskData() {
      const task = this.application && this.application.task
      if (!task) return null
      return task.data != null ? task.data : task
    },
    prnValue() {
      if (!this.taskData || !this.taskData.payment) return null
      return this.taskData.payment.prn || null
    }
  },
  watch:{
    application:{
      handler(data){
        this.sourceId = data && data.sourceId
        this.taskId = data && data.taskId
        const task = data && data.task
        this.form.resolutionId = (task && task.data && task.data.id) || (task && task.id)
        this.form.queueId = this.taskId
      },
      deep:true
    },
    getDisputeResolutionStatuses(data){
      for(let i = 0; i<data.length; i++){
        let message = data[i]
        this.messages.push(message)
      }

      if(this.messages.length > 1){
        if(this.messages[this.messages.length - 1].status === "QUERIED"){
          this.isQueryResponse = true
        }
      }
    },
    getDisputeResolutionDetails(data){
      this.application.task.data = data.data
    },
    getDisputeResolutionStatusUpdate(){
      this.loading = false
      this.successToast("Filing Action!", "Completed Task Successfully")

      window.location.reload()
    },
    getDisputeResolutionEscalationSuccess(){
      this.loading = false
      this.successToast("Escalation Action!", "Task Escalated Successfully")
      this.$refs.escalateSubmissions.hide();
      window.location.reload()
    },
    getDisputeResolutionError(data){
      this.loading = false
      this.errorToast("Error", data.message)
    },
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/menu.css";
.title{
  font-size: 22px;
}

.icon{
  width: 170px;
}

th, td{
  font-size: 12px;
}

.btn-escalate{
  @apply border border-blue bg-white rounded-sm text-blue text-sm px-3 py-1 mx-1;
}

.btn-escalate:hover{
  @apply text-blue-dark;
}

.btn-approve{
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-query{
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-reject{
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-approve:hover{
  @apply bg-green border-green text-white;
}

.btn-query:hover{
  @apply bg-orange border-orange text-white;
}

.btn-reject:hover{
  @apply bg-red border-red text-white;
}

.btn-approve-hover{
  @apply bg-green border-green text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-query-hover{
  @apply bg-orange border-orange text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-reject-hover{
  @apply bg-red border-red text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-approve-hover:hover{
  @apply bg-green-dark;
}

.btn-query-hover:hover{
  @apply bg-orange-dark;
}

.btn-reject-hover:hover{
  @apply bg-red-dark;
}
</style>